<rooms-list-table></rooms-list-table>